import { useState } from 'react';
import PanelLayout from '../components/PanelLayout';

const modes = [
  {
    id: 'active',
    title: 'Aktif İş Arıyorum',
    description: 'Profiliniz tüm doğrulanmış spa işletmelerine görünür. Yeni fırsatlardan haberdar olun.',
    icon: 'ri-eye-line',
    color: 'bg-green-50 border-green-200',
    iconColor: 'text-green-600',
    badge: null,
  },
  {
    id: 'silent',
    title: 'Sessiz Kariyer',
    description: 'Yeni fırsatlara açık olun ama herkes tarafından görünmeyin. İsim, fotoğraf ve iletişim bilgileriniz gizli kalır; yalnızca yüksek uyumlu işletmelere kontrollü şekilde gösterilirsiniz.',
    icon: 'ri-eye-off-line',
    color: 'bg-soft-gold-50 border-soft-gold-200',
    iconColor: 'text-soft-gold-700',
    badge: 'Önerilen',
  },
  {
    id: 'not-available',
    title: 'Şu An Müsait Değilim',
    description: 'Profiliniz görünmez. CRM geçmişiniz korunur. Fırsat akışı durdurulur.',
    icon: 'ri-pause-circle-line',
    color: 'bg-gray-50 border-gray-200',
    iconColor: 'text-gray-500',
    badge: null,
  },
  {
    id: 'fully-hidden',
    title: 'Tam Gizli',
    description: 'Aramalarda görünmezsiniz. CRM pasif kalır. Yeni eşleşme oluşmaz.',
    icon: 'ri-lock-line',
    color: 'bg-gray-50 border-gray-200',
    iconColor: 'text-gray-500',
    badge: null,
  },
];

export default function GorunurlukPage() {
  const [selected, setSelected] = useState('silent');

  return (
    <PanelLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500">Görünürlük Ayarlarım</h1>
          <p className="text-sm text-gray-500 mt-1">
            Kimlerin sizi görebileceğini ve hangi bilgilerin paylaşılacağını kontrol edin.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {modes.map((mode) => {
            const isSelected = selected === mode.id;
            return (
              <button
                key={mode.id}
                onClick={() => setSelected(mode.id)}
                className={`relative text-left p-5 rounded-xl border-2 transition-all cursor-pointer ${
                  isSelected ? mode.color : 'bg-white border-gray-100 hover:border-gray-200'
                }`}
              >
                {mode.badge && (
                  <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-soft-gold-500 text-white text-[10px] font-bold">
                    {mode.badge}
                  </span>
                )}
                <div
                  className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${
                    isSelected ? 'bg-white/80' : 'bg-gray-50'
                  }`}
                >
                  <span className={`w-5 h-5 flex items-center justify-center ${mode.iconColor}`}>
                    <i className={`${mode.icon} text-lg`} />
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-deep-navy-500 mb-1">{mode.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed">{mode.description}</p>
                {isSelected && (
                  <div className="mt-3 flex items-center gap-1 text-dark-teal-500">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-fill text-sm" />
                    </span>
                    <span className="text-xs font-medium">Aktif mod</span>
                  </div>
                )}
              </button>
            );
          })}
        </div>

        {/* Info Card */}
        <div className="mt-6 bg-dark-teal-50 border border-dark-teal-100 rounded-xl p-4 flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-dark-teal-500 shrink-0 mt-0.5">
            <i className="ri-information-line text-base" />
          </span>
          <div>
            <p className="text-sm font-medium text-dark-teal-700">Görünürlük değişikliği anında aktif olur.</p>
            <p className="text-xs text-dark-teal-600 mt-1">
              Mod değiştirdiğinizde devam eden görüşmeler etkilenmez. Yalnızca yeni eşleşme talepleri seçtiğiniz moda göre filtrelenir.
            </p>
          </div>
        </div>
      </div>
    </PanelLayout>
  );
}